import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  listLoading: false,
  actionsLoading: null,
  totalCount: 0,
  entities: null,
  roles: null,
  centers: null,
  userStatusTypes: null,
  userForEdit: undefined,
  lastError: null,
  userForRead: false,
  pdfLoading: false,
};

export const callTypes = {
  list: "list",
  action: "action",
  pdf: "pdf",
};

export const LeaveRegisterSlice = createSlice({
  name: "LeaveRegister",
  initialState: initialState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else if (action.payload.callType === callTypes.pdf) {
        state.pdfLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else if (action.payload.callType === callTypes.pdf) {
        state.pdfLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    pdfFetched: (state, action) => {
      state.pdfLoading = false;
    },
    LeaveRegisterFetched: (state, action) => {
      const entities = action.payload.data?.data.rows;
      const totalResult = action.payload.data?.data.totalResults;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalResult;
    },
    clearState: (state, action) => {
      state.listLoading = false;
      state.actionsLoading = null;
      state.totalCount = 0;
      state.entities = null;
      state.roles = null;
      state.centers = null;
      state.userStatusTypes = null;
      state.userForEdit = undefined;
      state.lastError = null;
      state.userForRead = false;
      state.pdfLoading = false;
    },
  },
});
